module.exports = __webpack_public_path__ + "img/comp-empty-state.5140aa85.png";